module.exports = __webpack_public_path__ + "static/imagem-04-equipamentos-52a149aeacd4e22116712ed348f02741.jpg";